import PropertyCard from "@/components/molecules/HouseCard"
import { House } from "@/app/types"

type PropertiesProps = {
  properties: House[]
  grid: number
}

export const PropertiesList = ({ properties, grid }: PropertiesProps) => {
  return (
    <div
      className={
        grid === 3
          ? `grid grid-flow-row gap-4 md:grid-cols-2 lg:grid-cols-3 lg:gap-6`
          : `grid grid-flow-row gap-2 md:grid-cols-1 lg:grid-cols-2 lg:gap-3`
      }
    >
      {properties.map((property) => (
        <PropertyCard key={property.id} {...property} />
      ))}
    </div>
  )
}
